module.exports = __webpack_public_path__ + "static/media/yu.e8e83ce7.png";